import { Splide } from '@splidejs/splide'

import { getElements } from '../../../../Resources/Private/TypeScript/Utility/Dom'

class TestimonialSlider {
  private sliderOptions: object = {
    breakpoints: {
      1024: { perPage: 2 },
      768: { perPage: 1.1 },
    },
    focus: 'start',
    gap: '1.25rem',
    omitEnd: true,
    perPage: 3,
    type: 'slide',
  }

  private sliders: NodeListOf<HTMLElement>

  constructor() {
    this.sliders = getElements('testimonial-slider')
  }

  public init(): void {
    this.sliders.forEach((slider): void => {
      const maxItems = +slider.getAttribute('data-items')
      this.sliderOptions.perPage = maxItems > 0 ? maxItems : this.sliderOptions.perPage
      const splide = new Splide(slider, this.sliderOptions)

      splide.on('overflow', (isOverflow: boolean): void => {
        splide.options = { arrows: isOverflow, drag: isOverflow }
      })

      splide.mount()
    })
  }
}

const testimonialSlider = new TestimonialSlider()
testimonialSlider.init()
